export default "__VITE_ASSET__BbCULFeU__"